/*
  illustrArte · Fecha de entrega (21/10/2026)
  One engine for every delivery date on the site: announcement banner, product page,
  cart drawer / cart page and the "Entrega" line carried to checkout.
  Config: shop metafield illustrarte.delivery_promise (JSON), injected by
  snippets/delivery-promise-config.liquid as window.IADelivery.cfg.
  All dates are 'YYYY-MM-DD' strings in Madrid time; arithmetic is done in UTC.
*/
(function () {
  'use strict';
  if (window.IADelivery && window.IADelivery.engine) return;
  var D = window.IADelivery = window.IADelivery || {};
  var cfg = D.cfg || {};
  var TZ = cfg.tz || 'Europe/Madrid';

  /* ---------- clock & calendar ---------- */
  function madridNow() {
    var o = D.testNow ? new Date(D.testNow) : new Date();
    var p = {};
    new Intl.DateTimeFormat('en-CA', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' })
      .formatToParts(o).forEach(function (x) { p[x.type] = x.value; });
    return { date: p.year + '-' + p.month + '-' + p.day, mins: (+p.hour) * 60 + (+p.minute), secs: (+p.hour) * 3600 + (+p.minute) * 60 + (+p.second) };
  }
  function toUTC(s) { var a = s.split('-'); return Date.UTC(+a[0], +a[1] - 1, +a[2]); }
  function fromUTC(t) { return new Date(t).toISOString().slice(0, 10); }
  function addDays(s, n) { return fromUTC(toUTC(s) + n * 864e5); }
  function dow(s) { return new Date(toUTC(s)).getUTCDay(); }
  function inList(list, s) { return (list || []).indexOf(s) !== -1; }
  function inClosure(s) {
    return (cfg.closures || []).some(function (c) {
      if (typeof c === 'string') return c === s;
      return s >= c.from && s <= (c.to || c.from);
    });
  }
  function isWorkday(s) { var w = dow(s); return w !== 0 && w !== 6 && !inList(cfg.holidays, s); }
  function isDispatchDay(s) { return isWorkday(s) && !inClosure(s); }
  function nextDay(s, test) { var d = addDays(s, 1); while (!test(d)) d = addDays(d, 1); return d; }
  function addWorkdays(s, n) { var d = s; for (var i = 0; i < n; i++) d = nextDay(d, isWorkday); return d; }
  function cutoffMins() { var c = (cfg.cutoff || '14:00').split(':'); return (+c[0]) * 60 + (+c[1] || 0); }
  function inPeak(s) { var p = cfg.peak; return !!(p && p.from && s >= p.from && s <= p.to); }

  /* promise for one delivery key ('stock', 'printful', ...) and destination country */
  function promise(key, country) {
    var now = madridNow(), today = now.date;
    var es = (country || 'ES') === 'ES';
    if (key === 'stock') {
      var before = isDispatchDay(today) && now.mins < cutoffMins();
      var dispatch = before ? today : nextDay(today, isDispatchDay);
      var t = (cfg.stock && cfg.stock[es ? 'ES' : 'EU']) || (es ? [1, 1] : [3, 6]);
      var lo = t[0], hi = t[1];
      if (inPeak(dispatch) && cfg.peak.extraMax) hi += cfg.peak.extraMax;
      var from = addWorkdays(dispatch, lo), to = addWorkdays(dispatch, hi);
      var closedGap = false, d = today;
      while (d < dispatch) { if (inClosure(d) && dow(d) !== 0 && dow(d) !== 6) { closedGap = true; break; } d = addDays(d, 1); }
      return {
        key: key, today: today, dispatch: dispatch, from: from, to: to, single: from === to,
        shipsToday: before, closed: closedGap,
        secsToCutoff: before ? cutoffMins() * 60 - now.secs : 0
      };
    }
    var w = cfg.mto && cfg.mto[key];
    if (!w) return null;
    var x = es ? 0 : (cfg.mtoExtraNonES || 0);
    var f = addWorkdays(today, w[0] + x), tt = addWorkdays(today, w[1] + x);
    return { key: key, today: today, from: f, to: tt, single: f === tt, mto: true };
  }

  /* ---------- words ---------- */
  var L = (D.locale || 'es').toLowerCase();
  var lang = L.indexOf('pt') === 0 ? 'pt' : L.slice(0, 2);
  var INTL = { es: 'es-ES', en: 'en-GB', de: 'de-DE', fr: 'fr-FR', it: 'it-IT', nl: 'nl-NL', pt: 'pt-PT' };
  /* full weekday and month, e.g. 'viernes 23 de octubre', 'Friday 23 October', 'Freitag, 23. Oktober' */
  function fmt(s) {
    var out = new Intl.DateTimeFormat(INTL[lang] || 'es-ES', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' }).format(new Date(toUTC(s)));
    if (lang === 'es' || lang === 'pt') out = out.replace(',', '');
    return out;
  }
  var W = {
    es: { tomorrow: 'mañana, ', on: 'el ', get: 'Recíbelo ', between: 'Recíbelo entre el {a} y el {b}', mto: 'Hecho para ti · ', free: 'Envío gratis en España',
      banner: 'Pide en las próximas {t} y recíbelo {w}', bannerShip: 'Pide en las próximas {t} y sale hoy', closed: 'Estamos de vacaciones: tu pedido sale el {d} y lo recibes {w}',
      cart: 'Llega {w}', cartRange: 'Llega entre el {a} y el {b}', cartMto: 'Personalizados: llegan entre el {a} y el {b}', prop: 'Entrega' },
    en: { tomorrow: 'tomorrow, ', on: 'on ', get: 'Get it ', between: 'Get it between {a} and {b}', mto: 'Made for you · ', free: 'Free shipping in Spain',
      banner: 'Order within {t} to get it {w}', bannerShip: 'Order within {t} and it ships today', closed: "We're on holiday: your order ships on {d} and arrives {w}",
      cart: 'Arrives {w}', cartRange: 'Arrives between {a} and {b}', cartMto: 'Personalised items: arrive between {a} and {b}', prop: 'Delivery' },
    de: { tomorrow: 'morgen, ', on: 'am ', get: 'Lieferung ', between: 'Lieferung zwischen {a} und {b}', mto: 'Für dich gefertigt · ', free: 'Kostenloser Versand in Spanien',
      banner: 'Bestelle innerhalb von {t}, Lieferung {w}', bannerShip: 'Bestelle innerhalb von {t}, Versand noch heute', closed: 'Wir sind im Urlaub: Versand am {d}, Lieferung {w}',
      cart: 'Lieferung {w}', cartRange: 'Lieferung zwischen {a} und {b}', cartMto: 'Personalisierte Artikel: Lieferung zwischen {a} und {b}', prop: 'Lieferung' },
    fr: { tomorrow: 'demain, ', on: 'le ', get: 'Livraison ', between: 'Livraison entre le {a} et le {b}', mto: 'Fait pour vous · ', free: 'Livraison gratuite en Espagne',
      banner: 'Commandez dans les {t} : livraison {w}', bannerShip: "Commandez dans les {t} : expédition aujourd'hui", closed: 'Nous sommes en congés : expédition le {d}, livraison {w}',
      cart: 'Livraison {w}', cartRange: 'Livraison entre le {a} et le {b}', cartMto: 'Articles personnalisés : livraison entre le {a} et le {b}', prop: 'Livraison' },
    it: { tomorrow: 'domani, ', on: '', get: 'Consegna ', between: 'Consegna tra {a} e {b}', mto: 'Fatto per te · ', free: 'Spedizione gratuita in Spagna',
      banner: 'Ordina entro {t}: consegna {w}', bannerShip: 'Ordina entro {t}: spedizione oggi', closed: 'Siamo in ferie: spedizione {d}, consegna {w}',
      cart: 'Consegna {w}', cartRange: 'Consegna tra {a} e {b}', cartMto: 'Articoli personalizzati: consegna tra {a} e {b}', prop: 'Consegna' },
    nl: { tomorrow: 'morgen, ', on: 'op ', get: 'Levering ', between: 'Levering tussen {a} en {b}', mto: 'Voor jou gemaakt · ', free: 'Gratis verzending in Spanje',
      banner: 'Bestel binnen {t}, levering {w}', bannerShip: 'Bestel binnen {t}, vandaag verzonden', closed: 'We zijn met vakantie: verzending op {d}, levering {w}',
      cart: 'Levering {w}', cartRange: 'Levering tussen {a} en {b}', cartMto: 'Gepersonaliseerde artikelen: levering tussen {a} en {b}', prop: 'Levering' },
    pt: { tomorrow: 'amanhã, ', on: '', get: 'Entrega ', between: 'Entrega entre {a} e {b}', mto: 'Feito para si · ', free: 'Envio grátis em Espanha',
      banner: 'Encomende nos próximos {t}: entrega {w}', bannerShip: 'Encomende nos próximos {t}: enviado hoje', closed: 'Estamos de férias: envio {d}, entrega {w}',
      cart: 'Entrega {w}', cartRange: 'Entrega entre {a} e {b}', cartMto: 'Artigos personalizados: entrega entre {a} e {b}', prop: 'Entrega' }
  }[lang] || null;
  W = W || {};
  function tpl(s, o) { return s.replace(/\{(\w)\}/g, function (_, k) { return o[k]; }); }
  function when(p, s) { return (s === addDays(p.today, 1) ? W.tomorrow : W.on) + fmt(s); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function countdown(sec) {
    var t = Math.max(1, Math.ceil(sec / 60)), h = Math.floor(t / 60), m = t % 60;
    return h > 0 ? h + ' h' + (m ? ' ' + m + ' min' : '') : m + ' min';
  }
  function propValue(p) { return p.single ? fmt(p.from) : fmt(p.from) + ' – ' + fmt(p.to); }

  /* ---------- custom element ---------- */
  var country = (D.country || 'ES').toUpperCase();
  var ICON = D.icon || '';

  function renderProduct(el) {
    var key = el.getAttribute('data-key');
    var avail = {}; try { avail = JSON.parse(el.getAttribute('data-avail') || '{}'); } catch (e) {}
    var form = el.closest('.product-detail, .product-info, main') || document;
    var input = form.querySelector('form[action*="/cart/add"] [name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
    var vid = input ? String(input.value) : '';
    if (vid && avail[vid] === false) { el.hidden = true; return; }
    var p = promise(key, country);
    if (!p) { el.hidden = true; return; }
    var main = p.single ? '<strong>' + esc(W.get + when(p, p.from)) + '</strong>'
      : '<strong>' + esc(tpl(W.between, { a: fmt(p.from), b: fmt(p.to) })) + '</strong>';
    if (p.mto) main = esc(W.mto) + main;
    var sub = country === 'ES' && !p.mto ? '<span class="ia-dp__sub">' + esc(W.free) + '</span>' : '';
    var html = (ICON ? '<img class="ia-dp__icon" src="' + ICON + '" alt="" width="64" height="48" loading="lazy">' : '') +
      '<span class="ia-dp__text">' + main + sub + '</span>';
    if (el.__html !== html) { el.innerHTML = html; el.__html = html; }
    el.hidden = false;
  }

  function renderBanner(el) {
    if (country !== 'ES') { el.hidden = true; return; }
    var p = promise('stock', 'ES');
    var bar = el.closest('announcement-bar');
    var show = false, txt = '';
    if (p.closed) {
      show = true; txt = tpl(W.closed, { d: fmt(p.dispatch), w: p.single ? when(p, p.from) : tpl(W.between, { a: fmt(p.from), b: fmt(p.to) }).replace(W.get, '') });
    } else if (p.shipsToday && p.secsToCutoff > 0) {
      show = true;
      txt = p.single ? tpl(W.banner, { t: countdown(p.secsToCutoff), w: when(p, p.from) }) : tpl(W.bannerShip, { t: countdown(p.secsToCutoff) });
    }
    el.hidden = !show;
    if (bar) bar.classList.toggle('ia-dp-banner-on', show);
    if (show) {
      var html = '<span class="ia-dp-banner__text">' + esc(txt) + '</span>';
      if (el.__html !== html) { el.innerHTML = html; el.__html = html; }
    }
  }

  function renderCart(el) {
    var keys = []; try { keys = JSON.parse(el.getAttribute('data-keys') || '[]'); } catch (e) {}
    var lines = [], hasStock = keys.indexOf('stock') !== -1, mto = null;
    if (hasStock) {
      var p = promise('stock', country);
      lines.push(p.single ? tpl(W.cart, { w: when(p, p.from) }) : tpl(W.cartRange, { a: fmt(p.from), b: fmt(p.to) }));
    }
    keys.forEach(function (k) {
      if (k === 'stock') return;
      var q = promise(k, country); if (!q) return;
      if (!mto || q.to > mto.to) mto = q;
    });
    if (mto) lines.push(hasStock ? tpl(W.cartMto, { a: fmt(mto.from), b: fmt(mto.to) }) : tpl(W.cartRange, { a: fmt(mto.from), b: fmt(mto.to) }));
    if (!lines.length) { el.hidden = true; return; }
    var html = (ICON ? '<img class="ia-dp__icon" src="' + ICON + '" alt="" width="64" height="48" loading="lazy">' : '') +
      '<span class="ia-dp__text">' + lines.map(function (l) { return '<strong>' + esc(l) + '</strong>'; }).join('<br>') + '</span>';
    var fresh = el.__html !== html;
    if (fresh) { el.innerHTML = html; el.__html = html; }
    el.hidden = false;
    if (fresh || !el.__synced) { el.__synced = true; scheduleSync(el); }
  }

  /* ---------- carry the date on each cart line (shows at checkout, saved on the order) ---------- */
  var syncTimer = null, syncing = false;
  var OLD = /^(entrega|delivery|lieferung|livraison|consegna|levering|estimated delivery|entrega\/delivery)/i;
  function scheduleSync(el) {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () { syncLines(el); }, 600);
  }
  function syncLines(el) {
    if (syncing) return;
    var map = {}; try { map = JSON.parse(el.getAttribute('data-map') || '{}'); } catch (e) {}
    syncing = true;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var jobs = [];
        cart.items.forEach(function (it) {
          var key = map[String(it.variant_id)];
          var props = {}, changed = false;
          Object.keys(it.properties || {}).forEach(function (k) {
            if (OLD.test(k) && k !== W.prop) { changed = true; return; }
            if (it.properties[k] !== null && it.properties[k] !== '') props[k] = it.properties[k];
          });
          if (key) {
            var p = promise(key, country);
            if (p) {
              var v = propValue(p);
              if (props[W.prop] !== v) { props[W.prop] = v; changed = true; }
              var iso = p.from + (p.single ? '' : '/' + p.to);
              if (props._entrega_iso !== iso) { props._entrega_iso = iso; changed = true; }
            }
          }
          if (changed) jobs.push({ key: it.key, quantity: it.quantity, properties: props });
        });
        return jobs.reduce(function (chain, j) {
          return chain.then(function () {
            return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/change.js', {
              method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: j.key, quantity: j.quantity, properties: j.properties })
            });
          });
        }, Promise.resolve()).then(function () { return jobs.length; });
      })
      .then(function (n) {
        syncing = false;
        if (n) document.querySelectorAll('cart-form').forEach(function (f) { if (typeof f.refresh === 'function') f.refresh(); });
      })
      .catch(function () { syncing = false; });
  }

  var all = new Set();
  function render(el) {
    var m = el.getAttribute('data-mode');
    try {
      if (m === 'product') renderProduct(el);
      else if (m === 'banner') renderBanner(el);
      else if (m === 'cart') renderCart(el);
    } catch (e) { el.hidden = true; if (window.console) console.warn('ia-delivery', e); }
  }
  if (!customElements.get('ia-delivery')) {
    customElements.define('ia-delivery', class extends HTMLElement {
      connectedCallback() { all.add(this); render(this); }
      disconnectedCallback() { all.delete(this); }
    });
  }
  /* banner counts down; product line follows the variant picker; everything rolls over at 14:00 / midnight */
  setInterval(function () {
    all.forEach(function (el) { if (el.getAttribute('data-mode') !== 'cart') render(el); });
  }, 1000);
  setInterval(function () {
    all.forEach(function (el) { if (el.getAttribute('data-mode') === 'cart') render(el); });
  }, 60000);

  D.engine = { promise: promise, fmt: fmt, madridNow: madridNow, render: render };
})();
